import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import {
  CalendarJobsV2Item,
  CalendarJobsV2Response,
  Job,
  JobList,
  Vehicle
} from '../models/interfaces'


@Injectable({
  providedIn: 'root'
})
export class JobScheduleService {

constructor(private http: HttpClient ) { }

  public getJobListByDate(startDate : string , endDate: string): Observable<JobList> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    return this.http.get<CalendarJobsV2Response>(environment.APIENDPOINT + '/v2/jobs/calendar', {
      headers: this.setHeaders(),
      params,
      responseType: 'json'
    }).pipe(
      map(response => this.mapCalendarResponse(response))
    );
  }

  private mapCalendarResponse(response: CalendarJobsV2Response): JobList {
    const responseJobs = response && Array.isArray(response.jobList) ? response.jobList : [];

    return {
      noOfJobs: response && typeof response.noOfJobs === 'number' ? response.noOfJobs : 0,
      jobList: responseJobs
        .filter(job => job != null)
        .map(job => this.mapCalendarJob(job))
    };
  }

  private mapCalendarJob(item: CalendarJobsV2Item): Job {
    const vehicle = item && item.vehicle;
    const customer = item && item.customer;
    const status = item && item.status;

    return {
      jobId: item && item.jobId != null ? item.jobId : undefined,
      jobCode: item && item.jobCode != null ? item.jobCode : '',
      jobType: item && item.jobType != null ? item.jobType : '',
      jobDescription: item && item.jobDescription != null ? item.jobDescription : '',
      dropOffTime: item && item.dropOffTime != null ? item.dropOffTime : undefined,
      pickUpTime: item && item.pickUpTime != null ? item.pickUpTime : undefined,
      vehicle: {
        vehicleNumber: vehicle && vehicle.vehicleNumber != null ? vehicle.vehicleNumber : ''
      } as Vehicle,
      customer: {
        firstName: customer && customer.firstName != null ? customer.firstName : '',
        lastName: customer && customer.lastName != null ? customer.lastName : '',
        contactNumber: customer && customer.contactNumber != null ? customer.contactNumber : ''
      },
      status: {
        id: status && status.id != null ? status.id : 0,
        code: status && status.code != null ? status.code : '',
        description: status && status.description != null ? status.description : ''
      }
    };
  }

  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}
